module.exports = __webpack_public_path__ + "img/image16.5f38ba22.jpeg";